import { useParams, useNavigate } from 'react-router-dom';
import { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Collapse,
  Container,
  Row,
  Col,
  FormGroup,
  Form,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label
} from "reactstrap";
import { URL } from "../../api";
import axiosInstance from "../../Request";
import { isLoggedIn } from '../../util/common.js';

import SetAssignModal from "./setAssignModal";

const PrivilegeManagement = () => {
const navigate = useNavigate();
const logged = isLoggedIn();
const { cid, lid } = useParams();

const [selectedUserId, setSelectedUserId] = useState('');
const [userList, setUserList] = useState([]);
const [privilegesList, setPrivilegesList] = useState([]);
const [collapseState, setCollapseState] = useState({});
const [modalOpen, setModalOpen] = useState(false);
const [newPrivilege, setNewPrivilege] = useState({ title: "", subtitle: "", privilege: "", titleid: "" });
const [isAddingTitle, setIsAddingTitle] = useState(false);
const [allPrivilegesList, setAllPrivilegesList] = useState([]);
const [assignModalOpen, setAssignModalOpen] = useState(false);
const [selectedUserA, setSelectedUserA] = useState('');
const [selectedUserB, setSelectedUserB] = useState('');



  // Fetch data when component mounts or relevant params change
  useEffect(() => {
    if (!logged) {
      navigate('/auth/login');
      return;
    }

    const fetchData = async () => {
      try {
        const [userResponse, privilegeResponse] = await Promise.all([
          axiosInstance.get(URL.GET_USER_LIST),
          axiosInstance.get(URL.GET_PRIVILEGE_LIST),
        ]);

        const users = userResponse.data;
        const privileges = privilegeResponse.data;

        const groupedPrivileges = privileges.reduce((acc, item) => {
          const key = item.title_id;
          if (!acc[key]) acc[key] = { title_id: key, title: item.title?.trim() || "", privileges: [] };
          acc[key].privileges.push(item);
          return acc;
        }, {});

        setUserList(Array.isArray(users) ? users : []);
        setAllPrivilegesList(Object.values(groupedPrivileges)); // Keep original list
        setPrivilegesList(Object.values(groupedPrivileges));    // For initial display
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [logged, cid, lid]);
  const fetchUserPrivileges = async (userId) => {
   try {
        const response = await axiosInstance.get(`${URL.USER_PRIVILEGE}?user_id=${userId}`);
        const privileges = response.data;

        const groupedPrivileges = privileges.reduce((acc, item) => {
          if (!acc[item.title]) acc[item.title] = [];
          acc[item.title].push(item);
          return acc;
        }, {});

      setPrivilegesList(Object.entries(groupedPrivileges).map(([title, privileges]) => ({
        id: title,
        title,
        privileges,
      })));
    } catch (error) {
      console.error("Error fetching user privileges:", error);
    }
  };

  const handleUserChange = (e) => {
    const userId = e.target.value;
    setSelectedUserId(userId);
    if (userId) fetchUserPrivileges(userId);
  };

  const toggleCollapse = (id) => setCollapseState(prev => ({ ...prev, [id]: !prev[id] }));
  const toggleModal = () => setModalOpen(prev => !prev);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewPrivilege(prev => ({ ...prev, [name]: value, ...(name === "title" && { titleid: value }) }));
  };

  const handlePrivilegeChange = async (privilegeKey, newValue, privilegeId, userId) => {
    // Optimistic UI update
    setPrivilegesList(prevList => prevList.map(group => ({
      ...group,
      privileges: group.privileges.map(priv =>
        priv.privilege === privilegeKey ? { ...priv, privilege_value: newValue } : priv
      ),
    })));

    // API call to update privilege
    try {
        const response = await axiosInstance.post(
          URL.UPDATE_USER_PRIVILEGE,
          {
            userId: parseInt(userId),
            privilegeId: parseInt(privilegeId),
            privilegeType: newValue
          },
          { withCredentials: true }
        );

        const result = response.data;
        if (response.status !== 200) {
          console.error("Failed to update privilege:", result.message);
          alert("Failed to update privilege: " + (result.message || "Unknown error"));
        }
      } catch (error) {
        console.error("API error:", error);
        alert("Error updating privilege");
      }
  };
const handleSubmit = async (e) => {
  e.preventDefault();

  try {
  if (isAddingTitle) {
    // User wants to add a new title — only call SET_TITLE
    const res = await axiosInstance.post(
      URL.SET_TITLE,
      { title: newPrivilege.title },
      { withCredentials: true }
    );

    const data = res.data;
    if (res.status !== 200) {
      alert(data.message || "Failed to add title");
      return;
    }

    alert(data.message || "Title added successfully");

    // Reset state and refresh titles
    setNewPrivilege({ title: "", subtitle: "", privilege: "", titleid: "" });
    setIsAddingTitle(false);
    toggleModal();
    // fetchUserPrivileges(selectedUserId);
    window.location.reload();
  } else {
    // User selected an existing title — call SET_SUBTITLE only
    const payload = {
      titleId: parseInt(newPrivilege.titleid, 10),
      subtitle: newPrivilege.subtitle.trim(),
    };

    const response = await axiosInstance.post(
      URL.SET_SUBTITLE,
      payload,
      { withCredentials: true }
    );

    const result = response.data;

    if (response.status === 200) {
      alert(result.message || "Privilege added successfully");
      setNewPrivilege({ title: "", subtitle: "", privilege: "", titleid: "" });
      toggleModal();
      // fetchUserPrivileges(selectedUserId);
      window.location.reload();
    } else {
      alert(result.message || "Failed to add privilege");
    }
  }
} catch (err) {
  console.error("Error:", err);
  alert("Error occurred while processing request");
}
};

const handleTitlePrivilegeChange = async (group, newValue, userId) => {
  const updatedPrivileges = group.privileges.map(priv => ({
    ...priv,
    privilege_value: newValue
  }));

  // Optimistically update state
  setPrivilegesList(prevList =>
    prevList.map(g =>
      g.id === group.id
        ? { ...g, privileges: updatedPrivileges }
        : g
    )
  );

  // API calls for each privilege
  for (let priv of group.privileges) {
    try {
      await axiosInstance.post(
        URL.UPDATE_USER_PRIVILEGE,
        {
          userId: parseInt(userId),
          privilegeId: parseInt(priv.id),
          privilegeType: newValue
        },
        {
          withCredentials: true
        }
      );
    } catch (error) {
      console.error(`Error updating ${priv.subtitle}:`, error);
    }
  }
};



  return (
    <>

      <div className="header bg-gradient-info pb-6 pt-4 pt-md-7" />

      <Container className="mt--7" fluid>
        <Row className="mt-5">
          <Col xl="12">
            <Card className="shadow">
              <CardHeader className="border-0 mx-4">
                <Row className="align-items-center">
                  <Col xl="9">
                    <h3 className="mb-0">
                      Privilege
                      <Button className="ml-4" color="primary" onClick={toggleModal}>Add New Privilege</Button>
                      <Button className="ml-9" color="primary" onClick={() => setAssignModalOpen(true)}>Assign Privilege</Button>
                    </h3>
                  </Col>
                  <Col xl="3">
                    <Input type="select" value={selectedUserId} onChange={handleUserChange}>
                      <option value="">--Select User--</option>
                      {userList.map(user => (
                        <option key={user.id} value={user.id}>{user.user_name} -- {user.name}</option>
                      ))}
                    </Input>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody className='mx-4'>
            {privilegesList.length > 0 ? privilegesList.map((group, i) => (
              <Card key={i} className="mb-3">
                <CardHeader
                    onClick={() => toggleCollapse(group.id)}
                    style={{
                      backgroundColor: "#f8f9fe",
                      padding: "1rem 1.5rem",
                      border: "1px solid #d1d5db",
                      borderRadius: "0.5rem",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      flexWrap: "wrap",
                      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
                      // width: "100%" // Add this
                    }}
                  >
                    <div style={{ fontSize: "1.1rem", fontWeight: "600", color: "#007bff" }}>
                      {group.title}
                    </div>
                    <div
                      onClick={(e) => e.stopPropagation()}
                      style={{
                        marginRight: "11rem", 
                        display: "flex",
                        gap: "17rem"
                      }}
                    >
                      {[0, 1, 2].map((value) => (
                        <Label
                          key={value}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            fontSize: "0.9rem",
                           // marginLeft: value === 2 ? "-16px" : "0"
                          }}
                        >
                          <Input
                            type="radio"
                            name={`title-${group.id}`}
                            value={value}
                            onChange={() =>
                              handleTitlePrivilegeChange(group, value, selectedUserId)
                            }
                            checked={group.privileges.every(
                              (priv) => priv.privilege_value === value
                            )}
                            style={{ marginRight: "0.25rem" }}
                          />
                          {value === 0 ? "No Permission" : value === 1 ? "View" : "Edit"}
                        </Label>
                      ))}
                    </div>
                  </CardHeader>
                    <Collapse isOpen={collapseState[group.id]}>     
                      <CardBody>
                        <table className="table">
                          <thead>
                            <tr>
                              <th>Privilege Name</th>
                              <th>No Permission</th>
                              <th>View</th>
                              <th>Edit</th>
                            </tr>
                          </thead>
                          <tbody>
                            {group.privileges.map((priv, j) => (
                              <tr key={j}>
                                <td>{priv.subtitle || "N/A"}</td>
                                {[0, 1, 2].map(value => (
                                  <td key={value}>
                                    <Input
                                      type="radio"
                                      name={priv.privilege}
                                      value={value}
                                      checked={priv.privilege_value === value}
                                      onChange={() => handlePrivilegeChange(priv.privilege, value, priv.id, selectedUserId)}
                                    />
                                  </td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </CardBody>
                    </Collapse>
                  </Card>
                )) : <p>No privileges available</p>}

                <Row className="mt-4">
                  {/* <Col xl="2">
                    <Button color="primary">Save</Button>
                  </Col> */}
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      <Modal isOpen={modalOpen} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Add New Privilege</ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <Label for="title">Title</Label>
              {isAddingTitle ? (
                <>
                  <Input
                    type="text"
                    name="title"
                    id="title"
                    placeholder="Enter new title"
                    value={newPrivilege.title}
                    onChange={handleInputChange}
                    required
                  />
                  <Button color="link" size="sm" onClick={() => {
                    setIsAddingTitle(false);
                    setNewPrivilege(prev => ({ ...prev, title: "" }));
                  }}>
                    ← Back to title list
                  </Button>
                </>
              ) : (
                <Input
                  type="select"
                  name="title"
                  id="title"
                  value={newPrivilege.title}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "__add_new__") {
                      setIsAddingTitle(true);
                      setNewPrivilege(prev => ({ ...prev, title: "" }));
                    } else {
                      handleInputChange(e);
                    }
                  }}
                  required
                >
                  <option value="">--Select Title--</option>
                  {[...new Map(allPrivilegesList.map(item => [item.title_id, item])).values()].map((item, index) => (
                    <option key={index} value={item.title_id}>{item.title}</option>
                  ))}
                  <option value="__add_new__">+ Add New Title</option>
                </Input>
              )}
            </FormGroup>

            {!isAddingTitle && (
              <FormGroup>
                <Label for="subtitle">Subtitle</Label>
                <Input
                  type="text"
                  name="subtitle"
                  id="subtitle"
                  value={newPrivilege.subtitle}
                  onChange={handleInputChange}
                />
              </FormGroup>
            )}
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleModal}>Cancel</Button>
          <Button color="primary" type="submit" onClick={handleSubmit}>Submit</Button>
        </ModalFooter>
      </Modal>

      <SetAssignModal
        assignModalOpen={assignModalOpen}
        setAssignModalOpen={setAssignModalOpen}
        selectedUserA={selectedUserA}
        selectedUserB={selectedUserB}
        setSelectedUserA={setSelectedUserA}
        setSelectedUserB={setSelectedUserB}
        userList={userList}
        isOpen={assignModalOpen}
        toggle={() => setAssignModalOpen(!assignModalOpen)}
      />

    </>
  );


};

export default PrivilegeManagement;